// extracted by mini-css-extract-plugin
export default {"tableAvatar":"PMTable_tableAvatar__pOAjb","tableAvatar__img":"PMTable_tableAvatar__img__Bp+5k","rank":"PMTable_rank__aZq7Y"};